
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"50","height":"50","rx":"4","fill":"#E9E9E9"}}),_c('path',{attrs:{"d":"M29.287 12.14l2.17 2.17a3.032 3.032 0 004.285 4.287l2.119 2.118L20.713 37.86l-2.118-2.118a3.031 3.031 0 10-4.287-4.287l-2.169-2.168 17.148-17.148zm-3.38 8.158a1.135 1.135 0 100-2.27 1.135 1.135 0 000 2.27zm2.468 2.466a1.135 1.135 0 10-.003-2.27 1.135 1.135 0 00.003 2.27zm2.467 2.468a1.136 1.136 0 10-.002-2.272 1.136 1.136 0 00.002 2.272zM29.287 10l-1.07 1.07L11.07 28.217 10 29.287l1.07 1.07 2.17 2.17 1.07 1.07 1.07-1.07a1.519 1.519 0 012.147 2.147l-1.07 1.068 1.07 1.07 2.118 2.118 1.07 1.07 1.07-1.07L38.93 21.782l1.07-1.07-1.07-1.07-2.118-2.117-1.066-1.068-1.07 1.07a1.519 1.519 0 11-2.148-2.147l1.07-1.07-1.07-1.07-2.17-2.17-1.07-1.07z","fill":"#6349E9"}})])
          )
        }
      }
    